import { ModalProps } from "antd/lib/modal/Modal";
import { Col, message, Modal, Row, Select } from "antd";
import styles from "./index.module.scss";
import React, { useContext, useImperativeHandle, useState } from "react";
import {
    copyChapter,
    findCourse
} from "../../../../../../service/CourseDetail/chapter";
import useRequest from "../../../../../../utils/useRequest";
import Form, { useForm } from "rc-field-form";
import FieldWithError from "../../../../../../components/FieldWithError";
import Style from "./index.module.scss";
import lodash from "lodash-es";
import { CourseContext } from "../../../../Store";
import useCurrentDate from "../../../../../../utils/useCurrentDate";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";
import useRequestFn from "../../../../../../utils/useRequestFn";
import className from "classnames";
import "../../../../../../style/public.scss";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
}

interface FormProp {
    id: number; //课程no
}

const DataModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({});
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const [form] = useForm<FormProp>();

        const [copyAction, { loading: copyLoading }] =
            useRequestFn(copyChapter);

        const [select, { loading: getLoading }] = useRequest(
            () => findCourse({ onlyHasChapter: true }),
            {},
            []
        );

        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();

        async function onFinish(data: FormProp) {
            const item = lodash.find(select, { id: data.id });
            if (!item) {
                return;
            }
            try {
                await copyAction({
                    content: {
                        batchNo,
                        courseNo: course.courseNo,
                        courseSeq: course.courseSeq
                    },
                    dcCourseChapterEntity: {
                        batchNo: item.batchNo,
                        courseNo: item.courseno,
                        courseSeq: item.courseseq
                    }
                });
                onOk?.();
                message.success("复制成功");
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        return (
            <Modal
                {...props}
                className={styles.root}
                onCancel={onCancel}
                maskClosable={false}
                title="复制章节"
                onOk={form.submit}
                okButtonProps={{
                    loading: copyLoading
                }}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    style={{ padding: "30px 0" }}>
                    <Row gutter={15}>
                        <Col span={6}>
                            <div
                                className={className(
                                    "required_overflow",
                                    "label32"
                                )}>
                                选择课程：
                            </div>
                        </Col>
                        <Col span={16}>
                            <FieldWithError
                                name="id"
                                rules={[
                                    { required: true, message: "请选择课程" }
                                ]}>
                                <Select
                                    style={{ width: "100%" }}
                                    loading={getLoading}>
                                    {select?.map(item => {
                                        return (
                                            <Select.Option
                                                value={item.id}
                                                key={item.id}>
                                                {item.coursename}-
                                                {item.courseno}-{item.courseseq}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </FieldWithError>
                            <p className={Style.tips}>
                                温馨提示：只能复制章节结构，不能复制章节内容，且章节列表按时间升序顺序显示，后添加成功的在章节列表的最下方。
                            </p>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
);

export default DataModal;
